import DapDSRating from './rating.component'

export * from './rating.component'
export default DapDSRating

DapDSRating.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-rating': DapDSRating
  }
}
